import {
    FaBars
} from "react-icons/fa";
import {
    NavLink as Link
} from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav `
  background: ${({ scrolled }) => (scrolled ? '#2ec4b6' : '#cbf3f0')};
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  height: 95px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  direction: rtl;
  position: static;
  top: 20px; /* TopBar height */
  bottom: 90px;
  margin-top: 45px;
  z-index: 1000;
  transition: background-color 0.9s ease-in-out;
  box-shadow: ${({ scrolled }) => (scrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none')};
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;



export const NavLink = styled(Link)
`
  color: #255b5a;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  transition: color 0.5s ease;

  &.active {
    color: #ff9f1c;
    font-weight: 700;

  }

  &:hover {
    color: ${({ scrolled }) => (scrolled ? '#fef9f4' : '#2ec4b6')};
  }
`;

export const Bars = styled(FaBars)
`
  display: none;
  color: #255b5a;

  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    left: 20px;
    top: 71px;
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.div `
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtn = styled.nav `
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)
`
  border-radius: 12px;
  background: #255b5a;
  padding: 8px 20px;
  color: #fff;
  font-size: 0.95rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #ff9f1c;
    color: #fff;
  }
`;


export const DropdownContainer = styled.div `
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const DropdownMenu = styled.div `
  position: absolute;
  top: 100%;
  right: 0;
  background: #cbf3f0b1;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  min-width: 200px;
  z-index: 999;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
`;

export const DropdownLink = styled(Link)
`
  color: #333;
  padding: 5.5px 28px;
  text-decoration: none;
  font-size: 1.2rem;
  &:hover {
    background: #f0f0f0;
  }
`;